import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../store";
import { useEffect } from "react";
import showToast from "../utils/toastNotifications";

const useSessionMonitor = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const checkTokenExpiration = () => {
      const token = localStorage.getItem("token");

      if (!token) return;

      try {
        const [, payloadBase64] = token.split(".");
        const decodedPayload = atob(payloadBase64);
        const tokenData = JSON.parse(decodedPayload);
        const expirationTime = tokenData.exp * 1000;

        if (Date.now() >= expirationTime) {
          localStorage.removeItem("token");
          dispatch(logout());
          showToast("error", "Session expired. Please sign in again");
          navigate("/signin", { replace: true });
        }
      } catch (error) {
        console.error("Error checking token expiration:", error);
        localStorage.removeItem("token");
        dispatch(logout());
        navigate("/signin", { replace: true });
      }
    };

    // Initial check
    const initialTimeout = setTimeout(checkTokenExpiration, 500);
    
    // Periodic checks
    const intervalId = setInterval(checkTokenExpiration, 60000);

    return () => {
      clearInterval(intervalId);
      clearTimeout(initialTimeout);
    };
  }, [dispatch, navigate]);
};

export default useSessionMonitor;